import { Route } from "@faire/web-api/Route";
import { props as brandsRouteProps } from "@faire/web-api/routes/brands";
import { props as brandAppLandingPageRouteProps } from "@faire/web-api/routes/brands/app";
import { props as personalizedBrandsRouteProps } from "@faire/web-api/routes/brands/brandToken";
import { props as brandsCategoryPageProps } from "@faire/web-api/routes/brands/category";
import { props as brandsPersonalizedPageProps } from "@faire/web-api/routes/brands/personalized";
import { props as brandsPricingProps } from "@faire/web-api/routes/brands/pricing";
import { props as brandsReferralOfferPageProps } from "@faire/web-api/routes/brands/referral-offer/brandLeadReferralBonusOfferToken";
import { props as brandsReferralProps } from "@faire/web-api/routes/brands/referral/brandLeadReferralToken";
import { Switch } from "@faire/web/ui/routing/Switch";
import React, { Suspense } from "react";

import { getSettingEnableNewNAMCommissionModelWebRetailer } from "@faire/retailer/settings/getSettingEnableNewNAMCommissionModelWebRetailer";
import { LazyBrandAppLandingPage } from "@faire/retailer/views/brands/app/LazyBrandAppLandingPage";
import { LazyCategoryLandingPage } from "@faire/retailer/views/brands/personalized-landing-page/LazyCategoryLandingPage";
import { LazyPersonalizedLandingPage } from "@faire/retailer/views/brands/personalized-landing-page/LazyPersonalizedLandingPage";

import { LazyBrandsLandingPage } from "./landing-page";
import { LazyKnownRetailers } from "./landing-page/LazyKnownRetailer";
import { LazyLandingPage } from "./landing-page/WithOffer/LazyLandingPage";
import { LazyBrandsPricingPage } from "./pricing/LazyBrandsPricingPage";

export const BrandsLandingPageRoutes: React.FC = () => (
  <Suspense fallback={null}>
    <Switch>
      <Route
        {...brandAppLandingPageRouteProps}
        component={LazyBrandAppLandingPage}
      />
      <Route
        {...brandsPersonalizedPageProps}
        component={LazyPersonalizedLandingPage}
      />
      <Route {...brandsCategoryPageProps} component={LazyCategoryLandingPage} />
      {getSettingEnableNewNAMCommissionModelWebRetailer() ? (
        <Route {...brandsPricingProps} component={LazyBrandsPricingPage} />
      ) : null}
      <Route {...brandsReferralOfferPageProps} component={LazyLandingPage} />
      <Route {...brandsReferralProps} component={LazyKnownRetailers} />
      <Route
        {...personalizedBrandsRouteProps}
        component={LazyBrandsLandingPage}
      />
      <Route {...brandsRouteProps} component={LazyBrandsLandingPage} />
    </Switch>
  </Suspense>
);
